import { StatusEnum } from "app/shared";
import moment from "moment";
import { ActivityVariantStatus } from ".";
import { IActivityVariant, ActivityVariantEntity } from "./types";

/**
 * ActivityVariant entity schema convert to model
 */
export function mapActivityVariantFromEntity(entity: ActivityVariantEntity): IActivityVariant {
    return {
        id: entity.id,
        placeId: entity.placeId,
        artists: entity.artists || [],
        activityId: entity.activityId,
        title: entity.title,
        adminTitle: entity.adminTitle || entity.title,
        startDate: entity.startDate ? moment(entity.startDate).utcOffset(0).format("YYYY-MM-DDTHH:mm") : "",
        order: entity.order || 0,
        endDate: entity.endDate && new Date(entity.endDate).getFullYear() > 1 ? moment(entity.endDate).utcOffset(0).format("YYYY-MM-DDTHH:mm") : "",
        status: entity.status,
        variantStatus: entity.variantStatus || ActivityVariantStatus.Published,
        publish: entity.isWebPublish || false,
        language: entity.language,
        relationId: entity.languageRelationId,
        createdBy: entity.createdBy,
        updatedBy: entity.modifiedBy,
        createdAt: entity.createdOn || entity.CreatedOn,
        updatedAt: entity.modifiedOn || entity.ModifiedOn
    }
}

/**
 * ActivityVariant model schema convert to entity
 */
export function mapActivityVariantFromModel(model: IActivityVariant): ActivityVariantEntity {
    return {
        id: model.id,
        placeId: model.placeId,
        artists: (model.artists || []).map(artist => ({ id: artist.id, roleId: artist.roleId })),
        activityId: model.activityId,
        title: model.title,
        adminTitle: model.adminTitle,
        order: model.order || 0,
        startDate: model.startDate,
        isCreateOtherLanguage: model.isCreateOtherLanguage,
        endDate: model.endDate || undefined,
        status: StatusEnum.Published,
        variantStatus: model.variantStatus || ActivityVariantStatus.Published,
        isWebPublish: model.publish || false,
        language: model.language,
        languageRelationId: model.relationId || undefined
    }
}

